import axios from '../utils/AxiosUtils';
import i18n from '../i18next';

import {
    LOAD_NOTIFICATIONS_SUCCESS,
    IMPORT_IN_PROGRESS_FINISHED,
    PUBLISH_IN_PROGRESS_FINISHED
} from './types';
import MessageUtils from "../utils/MessageUtils";
import { doLoadMenus } from "./restaurants/posmenu/MenuActions";

export const loadNotifications = (restaurantId) => {
    return (dispatch, getState) => {

        doLoadNotifications(dispatch, getState, restaurantId);
    };
};

const doLoadNotifications = (dispatch, getState, restaurantId) => {
    
    const url = `/notification`;

    axios().get(url)
        .then(response => loadNotificationsSuccess(dispatch, getState, response, restaurantId))
        .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:notificationsActions.loadNotificationsFailure')));
}

const loadNotificationsSuccess = (dispatch, getState, response, restaurantId) => {

    dispatch({ type: LOAD_NOTIFICATIONS_SUCCESS, payload: response.data });
};

const handleImportAndPublishNotifications = (dispatch, getState, response, restaurantId) => {
    let latestNotifications, difference;
    const notificationsLength = getState().notifications.length;

    difference = response.data.length - notificationsLength;
    latestNotifications = response.data.slice(0, difference);

    if (response.data.length > notificationsLength) {

        const newNotificationsCount = response.data.length - notificationsLength;

        for (let i = 0; i < newNotificationsCount; i++) {
            let currentNotification = response.data[i];


            if (currentNotification.type == 'IMPORT_FAILED' || currentNotification.type == 'IMPORT_COMPLETED') {

                dispatch({ type: IMPORT_IN_PROGRESS_FINISHED });

                if (currentNotification.type == 'IMPORT_COMPLETED' && restaurantId > 0) {
                    doLoadMenus(restaurantId, dispatch, getState);
                }

            } else if (currentNotification.type == 'PUBLISH_FAILED' || currentNotification.type == 'PUBLISH_COMPLETED') {
                dispatch({ type: PUBLISH_IN_PROGRESS_FINISHED });

                if (currentNotification.type == 'PUBLISH_COMPLETED' && restaurantId > 0) {
                    doLoadMenus(restaurantId, dispatch, getState);
                }
            }
        }
    }
}

export const deleteNotification = (notificationId) => {
    return (dispatch, getState) => {

        const url = `/notification/${notificationId}`;

        axios().delete(url)
            .then(() => doLoadNotifications(dispatch, getState))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:notificationsActions.deleteNotificationsFailure')));
    };
};


// WEBPACK FOOTER //
// ./src/actions/NotificationsActions.js